import React from 'react';
import './AboutUs.css';
import AboutHero from '../components/AboutHero';
import AboutVision from '../components/AboutVision';
import AboutMission from '../components/AboutMission';

import ProjectSection from '../components/ProjectSection';
import Footer from '../components/Footer';

export default function AboutUs() {
  return (
    <main className="about-page">
      <AboutHero />

      <section className="about-intro" id="philosophy">
        <div className="container">
          <div className="intro-grid">
            <div className="intro-copy">
              <span className="eyebrow">A BIT</span>
              <h2 className="intro-title">ABOUT US</h2>
              <p>
              Globstay Pvt Ltd is a premier real estate and hospitality brand 
              offering luxury villas and eco-friendly domes for sale in Almora, 
              Uttarakhand. Nestled in the heart of the Himalayas, 
              we specialize in curating exclusive hill properties that combine scenic beauty, 
              sustainability, and modern comfort — ideal for vacation homes, holiday rentals,
               or long-term investments.

              At Globstay, we believe in redefining tourism and hospitality through thoughtfully 
              designed living spaces that promote well-being, peace, and connection with nature. 
              Our geodesic domes and hilltop villas are built in prime tourist locations, offering panoramic views, premium amenities, and a tranquil environment for both personal retreats and guest experiences.

              
            </p>
            </div>

            <div className="intro-media">
              <div className="intro-image top">
                <img src="/1.png" alt="Mountain journey" />
              </div>
              <div className="intro-image bottom">
                <img src="/2.png" alt="Nature experience" />
              </div>
              <div className="intro-image overlay-left">
                <img src="/3.png" alt="Adventure" />
              </div>
              <div className="intro-badge">
                <div className="badge-number">10+</div>
                <div className="badge-label">Design</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AboutVision />

      <AboutMission />

      

      <ProjectSection />

      <section className="map-embed">
        <div className="container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3296.8825087929113!2d79.71973757532783!3d29.61818747514098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a0b70520cbeeff%3A0x5ab673a068ce580a!2sAmoda%20Sari!5e1!3m2!1sen!2sin!4v1761929670515!5m2!1sen!2sin"
            width="600"
            height="450"
            style={{ border: 0, width: '100%' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </main>
  );
}


